(function () {
  'use strict';

  var REQUEST_TIMEOUT = 12000;
  var MIN_FILTER_RESULTS = 4;
  var LEGACY_RECOMMENDATIONS = 'section.shopify-section[id$="__main-product-recommendations"]';

  function removeLegacyRecommendations(scope) {
    var sections = [];
    if (scope.matches && scope.matches(LEGACY_RECOMMENDATIONS)) sections.push(scope);
    if (scope.querySelectorAll) {
      sections = sections.concat(Array.prototype.slice.call(
        scope.querySelectorAll(LEGACY_RECOMMENDATIONS)
      ));
    }
    for (var i = 0; i < sections.length; i++) sections[i].remove();
  }

  function normalise(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/[’']/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function canonicalSize(value) {
    var size = normalise(value)
      .replace(/\b(?:uk|size|womens|women|mens|men|girls|girl|boys|boy)\b/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    var aliases = {
      'extra small': 'xs',
      'small': 's',
      'medium': 'm',
      'large': 'l',
      'extra large': 'xl',
      'extra extra large': 'xxl'
    };
    return aliases[size] || size;
  }

  function facetMatches(product, filter, expected) {
    var attributes = product && product.attributes ? product.attributes : {};
    var actual = filter === 'brand' ? product.vendor : attributes[filter];
    var expectedKey = normalise(expected);
    var actualKey = normalise(actual);
    if (!expectedKey || !actualKey) return false;
    if (filter === 'size') return canonicalSize(actual) === canonicalSize(expected);
    if (actualKey === expectedKey) return true;
    return String(actual || '').split(/[,/|]/).some(function (part) {
      return normalise(part) === expectedKey;
    });
  }

  function matchingProducts(products, filter, value) {
    if (filter === 'all') return products.slice();
    return products.filter(function (product) {
      return facetMatches(product, filter, value);
    });
  }

  function similarityScore(product, details) {
    var weights = { type: 35, style: 20, size: 20, colour: 15, brand: 10 };
    var score = 0;
    var possible = 0;
    Object.keys(weights).forEach(function (facet) {
      if (!details[facet]) return;
      possible += weights[facet];
      if (facetMatches(product, facet, details[facet])) score += weights[facet];
    });
    return possible ? Math.round((score / possible) * 100) : 0;
  }

  function similarityLabel(score) {
    if (score >= 90) return 'Excellent match';
    if (score >= 75) return 'Very close match';
    if (score >= 55) return 'Close match';
    return 'Related match';
  }

  function matchColour(value) {
    var colour = normalise(value);
    var palette = {
      beige: '#d8c4a6', black: '#1f2421', blue: '#5274c9', brown: '#8d6044',
      cream: '#f3ead3', green: '#4f8a62', grey: '#a9aeaa', orange: '#ed8a39',
      pink: '#e58bab', purple: '#9270c7', red: '#c94b4b', white: '#f7f7f2',
      yellow: '#f3df43'
    };
    var key = Object.keys(palette).find(function (name) { return colour.indexOf(name) !== -1; });
    return key ? palette[key] : '#c8ff3d';
  }

  function decorateSimilarity(grid, products, details) {
    var cards = grid.querySelectorAll('.pw-card');
    for (var i = 0; i < cards.length; i++) {
      var media = cards[i].querySelector('.pw-card__media');
      if (!media || !products[i]) continue;
      var score = similarityScore(products[i], details);
      var chip = document.createElement('span');
      var dot = document.createElement('i');
      chip.className = 'pw-colour-match-chip pw-similarity-match-chip';
      chip.setAttribute('aria-label', similarityLabel(score) + ', ' + score + ' percent match');
      chip.style.setProperty('--pw-match-colour', matchColour(details.colour));
      dot.setAttribute('aria-hidden', 'true');
      chip.appendChild(dot);
      chip.appendChild(document.createTextNode(similarityLabel(score) + ' · ' + score + '% match'));
      media.appendChild(chip);
    }
  }

  function initialBatchSize() {
    if (typeof window.matchMedia !== 'function') return 10;
    if (window.matchMedia('(max-width: 749px)').matches) return 4;
    if (window.matchMedia('(max-width: 1100px)').matches) return 8;
    return 10;
  }

  function sourceDetails(section) {
    return {
      brand: String(section.getAttribute('data-product-brand') || '').trim(),
      department: String(section.getAttribute('data-product-department') || '').trim(),
      type: String(section.getAttribute('data-product-type') || '').trim(),
      style: String(section.getAttribute('data-product-style') || '').trim(),
      colour: String(section.getAttribute('data-product-colour') || '').trim(),
      size: String(section.getAttribute('data-product-size') || '').trim()
    };
  }

  function viewAllLabel(filter, details) {
    if (filter === 'type') return 'View all ' + details.type;
    if (filter === 'style') return 'View all ' + details.style + ' styles';
    if (filter === 'size') return 'View all in size ' + details.size;
    if (filter === 'colour') return 'View all in ' + details.colour;
    if (filter === 'brand') return 'View all by ' + details.brand;
    return 'View all matches';
  }

  function updateViewAllLinks(section, filter, details, sku, title) {
    var searchUrl = String(section.getAttribute('data-search-url') || '/search').trim();
    var url = new URL(searchUrl, window.location.href);
    var parameter = filter === 'brand' ? 'vendor' : filter;
    var label = viewAllLabel(filter, details);

    if (filter === 'all') {
      url.searchParams.set('q', title || 'Preloved fashion');
      url.searchParams.set('similar_sku', sku);
      url.searchParams.set('similar_title', title);
    } else {
      url.searchParams.set('q', '*');
      if (details.department) url.searchParams.set('department', details.department);
      if (details.type) url.searchParams.set('type', details.type);
      if (details[filter]) url.searchParams.set(parameter, details[filter]);
    }

    var links = section.querySelectorAll('[data-pw-shop-similar-view-all]');
    for (var i = 0; i < links.length; i++) {
      links[i].href = url.toString();
      links[i].textContent = label + ' →';
    }
  }

  function initialise(section) {
    if (!section || section.getAttribute('data-pw-shop-similar-ready') === 'true') return;
    section.setAttribute('data-pw-shop-similar-ready', 'true');

    var grid = section.querySelector('[data-pw-shop-similar-grid]');
    var navigation = section.querySelector('[data-pw-shop-similar-navigation]');
    var summary = section.querySelector('[data-pw-shop-similar-summary]');
    var footer = section.querySelector('[data-pw-shop-similar-footer]');
    var showMore = section.querySelector('[data-pw-shop-similar-show-more]');
    var moreCount = section.querySelector('[data-pw-shop-similar-more-count]');
    var endpoint = String(section.getAttribute('data-catalog-api') || '').trim();
    var sku = String(section.getAttribute('data-product-sku') || '').trim();
    var title = String(section.getAttribute('data-product-title') || '').trim();
    var currentHandle = String(section.getAttribute('data-product-handle') || '').trim();
    var limit = Math.max(1, Math.min(50, Number(section.getAttribute('data-product-limit')) || 50));
    var renderer = window.PrewornProductCards || null;
    var details = sourceDetails(section);

    if (!grid || !endpoint || !sku || !renderer || typeof window.fetch !== 'function') return;

    var url = new URL(endpoint, window.location.href);
    url.searchParams.set('action', 'search');
    url.searchParams.set('page', '1');
    url.searchParams.set('limit', String(Math.max(12, limit)));
    url.searchParams.set('sort', 'featured');
    url.searchParams.set('include_facets', '0');
    url.searchParams.set('count_mode', 'none');
    url.searchParams.set('similar_sku', sku);
    url.searchParams.set('q', title || 'Preloved fashion');

    var controller = typeof window.AbortController === 'function'
      ? new window.AbortController()
      : null;
    var timer = controller ? window.setTimeout(function () {
      controller.abort();
    }, REQUEST_TIMEOUT) : null;

    window.fetch(url.toString(), {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      headers: { Accept: 'application/json' },
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Catalogue HTTP ' + response.status);
        return response.json();
      })
      .then(function (payload) {
        if (!payload || payload.source !== 'preworn_catalog_index' || !Array.isArray(payload.items)) {
          throw new Error('Invalid catalogue response');
        }

        var products = payload.items.filter(function (product) {
          return product && product.availableForSale !== false &&
            String(product.handle || '') !== currentHandle;
        }).slice(0, limit);

        if (!products.length) return;

        var activeFilter = 'all';
        var visibleCount = initialBatchSize();
        var filterButtons = section.querySelectorAll('[data-pw-shop-similar-filter]');
        var visibleDetailFilters = 0;

        function currentFilterValue() {
          if (activeFilter === 'all') return '';
          return details[activeFilter] || '';
        }

        function renderGrid() {
          var filtered = matchingProducts(products, activeFilter, currentFilterValue());
          var batch = initialBatchSize();
          var shown = filtered.slice(0, visibleCount);
          var remaining = Math.max(0, filtered.length - shown.length);

          grid.setAttribute('aria-busy', 'true');
          grid.innerHTML = renderer.renderList(shown);
          decorateSimilarity(grid, shown, details);
          renderer.bindWishlist(grid);
          if (typeof renderer.bindImages === 'function') renderer.bindImages(grid);
          grid.setAttribute('aria-busy', 'false');

          if (summary) {
            summary.textContent = 'Showing ' + shown.length + ' of ' + filtered.length +
              (activeFilter === 'all' ? ' closest matches' : ' matching pieces');
          }
          if (showMore) showMore.hidden = remaining === 0;
          if (moreCount) moreCount.textContent = remaining > 0
            ? '(' + Math.min(batch, remaining) + ')' : '';
          if (footer) footer.hidden = false;
          updateViewAllLinks(section, activeFilter, details, sku, title);
        }

        for (var i = 0; i < filterButtons.length; i++) {
          var button = filterButtons[i];
          var filter = String(button.getAttribute('data-pw-shop-similar-filter') || 'all');
          if (filter === 'all') continue;
          var value = String(button.getAttribute('data-filter-value') || details[filter] || '').trim();
          var count = matchingProducts(products, filter, value).length;
          var useful = !!value && count >= MIN_FILTER_RESULTS && count < products.length;
          button.hidden = !useful;
          if (useful) visibleDetailFilters += 1;
        }

        if (navigation) navigation.hidden = visibleDetailFilters === 0;

        for (var j = 0; j < filterButtons.length; j++) {
          filterButtons[j].addEventListener('click', function () {
            var nextFilter = String(this.getAttribute('data-pw-shop-similar-filter') || 'all');
            if (nextFilter !== 'all' && this.hidden) return;
            activeFilter = nextFilter;
            visibleCount = initialBatchSize();
            for (var index = 0; index < filterButtons.length; index++) {
              var isActive = filterButtons[index] === this;
              filterButtons[index].classList.toggle('is-active', isActive);
              filterButtons[index].setAttribute('aria-pressed', isActive ? 'true' : 'false');
            }
            renderGrid();
          });
        }

        if (showMore) showMore.addEventListener('click', function () {
          visibleCount += initialBatchSize();
          renderGrid();
        });

        renderGrid();
        section.hidden = false;
      })
      .catch(function (error) {
        grid.setAttribute('aria-busy', 'false');
        console.warn('[Preworn Product] Similar products unavailable.', error);
      })
      .then(function () {
        if (timer) window.clearTimeout(timer);
      });
  }

  function boot(scope) {
    scope = scope || document;
    removeLegacyRecommendations(scope);
    var sections = scope.querySelectorAll('[data-pw-shop-similar]');
    for (var i = 0; i < sections.length; i++) initialise(sections[i]);
    if (scope.matches && scope.matches('[data-pw-shop-similar]')) initialise(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
